// extracted by mini-css-extract-plugin
export var table = "_vp-0";